enum ModeName {
  ORDER = "order",
  CHECKOUT = "checkout",
  VOUCHER = "voucher",
  OVERVIEW = "overview"
}

export default ModeName;
